var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.25215 4.16667L2.49959 4.16667L2.49959 2.91667C2.49959 2.22656 3.05951 1.66667 3.74963 1.66667L7.91644 1.66667L9.58316 -4.73555e-07L13.75 -1.09282e-07C14.4401 -4.89492e-08 15 0.559896 15 1.25L15 8.75C15 9.44011 14.4401 10 13.75 10L3.33295 10C2.90325 10 2.5022 9.77865 2.27302 9.41146L0.192226 6.07812C-0.328624 5.2474 0.270352 4.16667 1.25215 4.16667ZM13.75 1.40625C13.75 1.32031 13.6796 1.25 13.5937 1.25L10.1014 1.25L8.43468 2.91667L3.90589 2.91667C3.81995 2.91667 3.74963 2.98698 3.74963 3.07292L3.74963 4.16667L11.0415 4.16667C11.4791 4.16667 11.8853 4.39583 12.1119 4.77083L13.75 7.48438L13.75 1.40625ZM3.33295 8.75L13.1249 8.75L11.1145 5.41667L1.24955 5.41667L3.33295 8.75Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.8a7d066423c5cc35844a90a3ea7ac4b9.svg";
export { ForwardRef as ReactComponent };